/** @jsxImportSource @emotion/react */
import { Button } from '@app/components/Atoms/Button'
import { css } from '@emotion/react'
import { Theme, useTheme } from '@mui/material'
import { ChevronRight } from '@mui/icons-material'

interface QuickLinkProps {
  label: string
  onClick?: () => void
  theme: Theme
}

export const QuickLink: React.FC<QuickLinkProps> = ({ label, onClick }) => {
  const theme = useTheme()
  return (
    <Button onClick={onClick} css={quickLinkStyles({ theme })}>
      <span>{label}</span>
      <ChevronRight />
    </Button>
  )
}

export const quickLinkStyles = ({ theme }: { theme: Theme }) => css`
  background-color: ${theme.palette.white.main};
  border: 2px solid ${theme.palette.blue.light};
  color: ${theme.palette.uintel.main};
  text-align: left;
  line-height: 1.4;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: ${theme.spacing(2, 4)};
  gap: ${theme.spacing(1)};

  &:hover {
    background-color: ${theme.palette.white.main};
    border: 2px solid ${theme.palette.blue.main};
    box-shadow:
      0px 2px 4px rgba(11, 41, 72, 0.1),
      inset 0 0 40px 500px ${theme.palette.blue.main}10;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1;
  }
`
